var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element)?_c(("" + (_vm.element.name)),{ref:"contentElement",tag:"component",staticClass:"document-type-element",attrs:{"element":_vm.element},on:{"close":_vm.closePopup}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }